import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header";

class AddDataTapeSettingService {
  addDataTapeSetting(data_tape_retention_years) {
    return axios.post(
      API + "company/company-settings/",
      {
        data_tape_retention_years: data_tape_retention_years,
      },
      { headers: authHeader() }
    );
  }
}

export default new AddDataTapeSettingService();